import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  position: absolute;
  top: 52px;
  z-index: 100000;
  background: var(--menu-color);
  padding: 8px;
  width: 190px;
  text-align: left;
  border-radius: 20px;
  box-shadow: var(--default-drop-shadow);
  color: var(--grey-0);
  max-height: 400px;
  left: 0;

  .settings-row {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-height: 44px;
    padding: 10px 12px;
    border: 0;
    border-radius: 10px;
    background: transparent;
    color: var(--grey-0);
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      background: var(--menu-color-hover);
    }

    &:focus-visible {
      outline: 2px solid var(--primary-cta-high-contrast);
      outline-offset: 1px;
    }

    svg path {
      fill: var(--grey-0);
    }
  }
`;
